import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export const FormDialog = ({ open, onOpenChange, title, onSubmit, submitLabel = "Save", testid, children }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-h-[90vh] overflow-y-auto border-white/10 bg-[#111827]">
      <DialogHeader><DialogTitle className="font-display text-2xl uppercase tracking-tight">{title}</DialogTitle></DialogHeader>
      <form
        className="space-y-4"
        data-testid={testid}
        onSubmit={(e) => { e.preventDefault(); onSubmit(); }}
      >
        {children}
        <Button type="submit" className="w-full rounded-full font-bold uppercase tracking-wider" data-testid={`${testid}-submit`}>{submitLabel}</Button>
      </form>
    </DialogContent>
  </Dialog>
);

export const SectionHead = ({ title, text, children }) => (
  <div className="flex flex-wrap items-end justify-between gap-4">
    <div>
      <h2 className="font-display text-3xl font-extrabold uppercase tracking-tight text-white sm:text-4xl">{title}</h2>
      {text && <p className="mt-1 text-sm text-slate-400">{text}</p>}
    </div>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);

export const Toggle = ({ checked, onChange, label, testid }) => (
  <label className="flex cursor-pointer items-center gap-3 text-sm text-slate-300">
    <input type="checkbox" className="h-4 w-4 accent-[#CCFF00]" checked={checked} onChange={(e) => onChange(e.target.checked)} data-testid={testid} />
    {label}
  </label>
);
